module.exports = __webpack_public_path__ + "static/media/carousel-new-5.d243be00.jpg";